import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const UnmappedColumnsModal = ({ open, columns, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="unmapped-modal-title"
    >
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="unmapped-modal-title" variant="h6" component="h2" color="error">
            Unmapped Columns Detected
          </Typography>
          <IconButton onClick={onClose} size="small">
            <MdClose />
          </IconButton>
        </Box>
        <Typography id="unmapped-modal-description" sx={{ mt: 2, mb: 2 }}>
          The following columns in the imported document are not recognized. Please revise the dataset and retry.
        </Typography>
        
        <Box 
          sx={{ 
            maxHeight: 200, 
            overflowY: "auto", 
            bgcolor: "#fff4f4", 
            p: 2, 
            borderRadius: 1,
            border: "1px solid #ffccd5"
          }}
        >
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {columns?.map((col, idx) => (
              <li key={idx} style={{ color: "#d32f2f", marginBottom: 4 }}>
                {col}
              </li>
            ))}
          </ul>
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button onClick={onClose} variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UnmappedColumnsModal;
